/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import "./InitialLoadScreen.css";
import { useNavigate } from "react-router-dom";
import loadingGif from "../../assets/gif/app-loader.gif";
import ROUTE_PATHS from "../../utils/routePaths";
import { useQuery } from "@tanstack/react-query";
import useWSMApi from "services/api/useWSMApi";
import { useLogout } from "services/LogoutProvider";

const InitialLoadScreen = () => {
  const navigate = useNavigate();
  const { handleLogout } = useLogout();
  const { fetchUserProfile } = useWSMApi();

  const { data: profileData, error } = useQuery({
    queryKey: ["fetch-user-profile"],
    queryFn: () => fetchUserProfile(),
    retry: false,
  });

  useEffect(() => {
    if (error) {
      handleLogout();
      return;
    }

    if (profileData) {
      localStorage.setItem("userProfileData", JSON.stringify(profileData));
      const timer = setTimeout(() => {
        navigate(ROUTE_PATHS.WSM_HOME, { replace: true });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [profileData, error, navigate]);

  return (
    <div className="wms-mobile-container">
      <div className="initial-load-screen-container">
        <img
          src={loadingGif}
          alt="Loading..."
          className="initial-load-loader"
        />
        <p className="initial-load-screen-title">Please wait</p>
        <p className="initial-load-screen-sub-title">We are taking you there</p>
      </div>
    </div>
  );
};

export default InitialLoadScreen;
